module.exports = __webpack_public_path__ + "static/img/adressR.d85adcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/adressR.png
// module id = rMqh
// module chunks = 1